import {
  REQUEST_GET_REPORT,
  UPDATE_GET_REPORT,
  RESPONSE_GET_REPORT,
  REQUEST_GET_REPORT_FAILURE,
  RESPONSE_TO_INITIAL_STATE,
} from '../actions/reportGetStateActions'

import { states } from './queriesStates'

const initialState = {
  dataState: states.NOT_REQUESTED,
  queryItems: {},
}

const reportGetStateReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_GET_REPORT: {
      let nextState = Object.assign({}, state)

      nextState.dataState = states.REQUEST
      nextState.queryItems = action.queryItems

      return Object.assign(
        {},
        state,
        nextState
      )
    }
    case UPDATE_GET_REPORT: {
      let nextState = Object.assign({}, state)

      nextState.queryItems = action.queryItems

      return Object.assign(
        {},
        state,
        nextState
      )
    }
    case RESPONSE_GET_REPORT: {
      return Object.assign(
        {},
        state,
        {
          dataState: states.READY
        }
      )
    }
    case REQUEST_GET_REPORT_FAILURE: {
      return Object.assign(
        {},
        state,
        {
          dataState: states.FAILURE
        }
      )
    }
    case RESPONSE_TO_INITIAL_STATE: {
      return Object.assign(
        {},
        state,
        initialState
      )
    }
    default:
      return state
  }
}

export default reportGetStateReducer